var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 390.88,
    viewBox: "0 0 500 390.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.499,
    cy: 0.498,
    r: 0.501,
    gradientTransform: "translate(0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f973b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdb2d0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.501,
    r: 0.427,
    gradientTransform: "translate(-0.241) scale(1.482 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f981bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdb2d0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "about3",
    transform: "translate(-45.7 -89.791)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_283",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 283",
    transform: "translate(233.244 166.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_279",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 279",
    transform: "translate(0 132.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1599",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1599",
    d: "M199,352.89s44.409-66.919,63.493-77.807c18.962-10.888,47.1-20.92,74.5-8.2s31.563,29.85,42.206,55.664-7.83,110.838-7.83,110.838l-144.114.122Z",
    transform: "translate(-199 -260.937)",
    fill: "#4052f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1600",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1600",
    d: "M287.483,287.133c-6.362,0-13.579-2.936-16.393-8.808-1.59-3.058-1.958-5.505-1.223-7.34a2.835,2.835,0,0,1,1.468-1.713l.367.856-.122-.489.122.367a2.044,2.044,0,0,0-.979,1.223c-.367.979-.489,2.936,1.223,6.484,3.3,6.606,12.478,9.3,19.085,7.952,6.239-1.223,17.494-6.973,19.819-11.867,1.468-3.181,1.835-5.383.979-6.851s-2.936-2.447-6.362-2.691l.122-.856c3.793.367,6.117,1.468,7.1,3.181,1.223,2.2.122,5.26-.979,7.585-2.447,5.26-13.946,11.01-20.553,12.356A8.913,8.913,0,0,1,287.483,287.133Z",
    transform: "translate(-183.251 -260.387)",
    fill: "#9caaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1601",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1601",
    d: "M364.258,366.044s-45.143-12.846-61.536-7.218c-16.393,5.75-49.914,4.894-56.275-9.053-6.239-13.946,3.915-42.573,3.915-42.573-9.909,24.712-11.255,43.185-8.2,56.887l1.713,56.4,116.588,2.325L343.094,375.22Z",
    transform: "translate(-189.682 -250.603)",
    fill: "#3a4fcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1602",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1602",
    d: "M369.851,354.7c-.122,7.952-.612,15.659-1.1,22.51C367.282,396.539,364.835,410,364.835,410l-31.808-5.628L268.8,393.114h0s80.987,12.6,92,0C365.569,387.609,368.26,371.216,369.851,354.7Z",
    transform: "translate(-183.408 -239.993)",
    fill: "#3750e2"
  }), /*#__PURE__*/React.createElement("image", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_50",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 50",
    width: 80.743,
    height: 94.2,
    transform: "translate(62.392 40.448)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABNCAYAAAASArI9AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANZJREFUeNrs2zEOhCAUBUDYM1l5ie33gPZewspDWWqxSiJEVOa1asHkYT4xhtBA+u88pO75BAEBAgSI5AtTI0CAAAECBAgxR9gaZVqhESBAgAABAgQIECDKTJcaAQIECBAgQIAAkTlUaQQIECBAgFgzjd0PhEaAAHF2utQIECBAgAABAgQIEGWmS40AAQIECBAgQIAAUWa61AiNAPE38eiHr9T3wqefOLfrjHsXa+QK+EOIMw8/KVvgLIgWoGLNvdkkxJ2hbgVRGyqGlyQX6jUQuVCLAAMAeo4+V1FRKfkAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1603",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1603",
    d: "M290.833,366.641l-1.957,27.281-6.484-1.59-10.4-2.691-2.691-.734-3.181-.856-24.957,2.324-4.894.489a42.368,42.368,0,0,1-6.117-4.649c-4.893-4.649-9.542-11.989-1.1-19.085,10.276-8.564,18.351-7.952,26.058-6.239,2.569.489,11.989,3.548,11.989,3.548l3.3.245,2.691.245Z",
    transform: "translate(-193.33 -238.844)",
    fill: "#fdb2d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1604",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1604",
    d: "M279.328,388.154l-16.271-4.16L238.1,386.319l4.771-6.484s18.106,2.691,21.776-1.835c0,0,3.058,3.3,10.766,2.691C280.918,380.2,280.306,385.1,279.328,388.154Z",
    transform: "translate(-190.266 -234.788)",
    fill: "#f78dbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1605",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1605",
    d: "M263.647,379.8a20.172,20.172,0,0,0,.245,8.931L261.2,388l1.1-24.1,2.691.245-.367,4.037C273.189,375.522,263.647,379.8,263.647,379.8Z",
    transform: "translate(-185.106 -237.938)",
    fill: "#f78dbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1606",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1606",
    d: "M370.409,374.089c-.122,7.952-.612,15.659-1.1,22.51-.489,5.995-.979,11.5-1.59,16.149-1.223,10.276-2.447,16.76-2.447,16.76l-14.314-2.569-17.494-3.058L266.3,412.136l2.08-26.914L326,393.785s-6.729-65.7-9.175-90.9S326,267.9,326,267.9C364.17,278.666,371.143,331.638,370.409,374.089Z",
    transform: "translate(-183.967 -259.382)",
    fill: "#4052f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1607",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1607",
    d: "M352.26,386.3c-1.223,10.276-2.447,16.76-2.447,16.76L335.5,400.491C341.372,398.167,348.346,394.007,352.26,386.3Z",
    transform: "translate(-168.509 -232.934)",
    fill: "#364fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1608",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1608",
    d: "M315.5,370s18.718-.612,21.531,10.521C337.031,380.522,331.893,373.427,315.5,370Z",
    transform: "translate(-172.977 -236.576)",
    fill: "#3a4fcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1609",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1609",
    d: "M312.7,371s18.6,2.08,19.819,13.457C332.519,384.579,328.359,376.75,312.7,371Z",
    transform: "translate(-173.602 -236.352)",
    fill: "#3a4fcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1610",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1610",
    d: "M271.09,364.3l-1.59,26.914,1.59.245,1.468-27.037Z",
    transform: "translate(-183.252 -237.848)",
    fill: "#9caaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1611",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1611",
    d: "M274.39,364.7l-1.59,27.159,1.59.245,1.468-27.281Z",
    transform: "translate(-182.515 -237.759)",
    fill: "#9caaf2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_280",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 280",
    transform: "translate(68.387 257.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1612",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1612",
    d: "M258.562,387.211s-1.223-12.6.979-23.611l5.628.489s-2.936,20.308-1.468,24.468Z",
    transform: "translate(-254.158 -363.6)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1613",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1613",
    d: "M258.96,386.343s-1.1-12.478.734-22.143l4.894.489s-2.936,19.207-1.713,22.877Z",
    transform: "translate(-254.066 -363.466)",
    fill: "#fcaa24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_24",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 24",
    cx: 7.218,
    cy: 5.995,
    rx: 7.218,
    ry: 5.995,
    transform: "translate(0 4.282)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_25",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 25",
    cx: 6.484,
    cy: 5.261,
    rx: 6.484,
    ry: 5.261,
    transform: "translate(0.734 5.016)",
    fill: "#fcaa24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1614",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1614",
    d: "M256.5,370.958s1.1-2.936,5.628-3.058A10.644,10.644,0,0,0,256.5,370.958Z",
    transform: "translate(-254.543 -362.64)",
    fill: "#ffc46e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1615",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1615",
    d: "M259.9,369.4v4.282l6.362-.367h-5.872Z",
    transform: "translate(-253.783 -362.304)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1616",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1616",
    d: "M261.669,379.123l-2.2-.245a.324.324,0,0,1-.367-.367v-.245a.324.324,0,0,1,.367-.367l2.2.245a.324.324,0,0,1,.367.367v.245A.391.391,0,0,1,261.669,379.123Z",
    transform: "translate(-253.962 -360.406)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1617",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1617",
    d: "M262.769,365.923l-2.2-.245a.324.324,0,0,1-.367-.367v-.245a.324.324,0,0,1,.367-.367l2.2.245a.324.324,0,0,1,.367.367v.245A.324.324,0,0,1,262.769,365.923Z",
    transform: "translate(-253.716 -363.354)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1618",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1618",
    d: "M262.669,367.023l-2.2-.245a.324.324,0,0,1-.367-.367v-.245a.324.324,0,0,1,.367-.367l2.2.245a.324.324,0,0,1,.367.367v.245C263.036,366.9,262.914,367.146,262.669,367.023Z",
    transform: "translate(-253.738 -363.109)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1619",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1619",
    d: "M261.669,380.223l-2.2-.245a.324.324,0,0,1-.367-.367v-.245a.324.324,0,0,1,.367-.367l2.2.245a.324.324,0,0,1,.367.367v.245A.391.391,0,0,1,261.669,380.223Z",
    transform: "translate(-253.962 -360.16)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1620",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1620",
    d: "M261.669,381.323l-2.2-.245a.324.324,0,0,1-.367-.367v-.245a.324.324,0,0,1,.367-.367l2.2.245a.324.324,0,0,1,.367.367v.245A.391.391,0,0,1,261.669,381.323Z",
    transform: "translate(-253.962 -359.914)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1621",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1621",
    d: "M261.669,382.423l-2.2-.245a.324.324,0,0,1-.367-.367v-.245a.324.324,0,0,1,.367-.367l2.2.245a.324.324,0,0,1,.367.367v.245A.391.391,0,0,1,261.669,382.423Z",
    transform: "translate(-253.962 -359.669)",
    fill: "#f9835a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_282",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 282",
    transform: "translate(32.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1622",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1622",
    d: "M297.273,261.117S330.06,232.245,309.14,196.4L290.3,229.309Z",
    transform: "translate(-210.853 -142.97)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1623",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1623",
    d: "M285.441,289.795c-8.319-1.223-11.377-6.606-12.478-9.787a11.841,11.841,0,0,1-.612-2.324l-.122-.612h0l-.856-3.058-.489-1.713-1.59-6.117-3.548-13.212-.245-1.1,34.132-15.17s.489,2.447,1.223,5.995c.489,2.08.979,4.649,1.59,7.34,2.08,8.808,5.016,19.207,7.952,22.265,0,.122.122.122.122.245C315.047,278.172,297.185,291.507,285.441,289.795Z",
    transform: "translate(-216.393 -133.968)",
    fill: "#fdb2d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1624",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1624",
    d: "M301.019,246.352c-3.181,10.766-17.739,28.627-23.366,28.382a11.954,11.954,0,0,1-7.463-3.548l-1.59-6.117c5.995-5.872,24.957-23.978,31.563-23.366C300.53,243.783,300.408,243.66,301.019,246.352Z",
    transform: "translate(-215.7 -132.854)",
    fill: "#ef8ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1625",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1625",
    d: "M316.759,229.1c0,1.713-.122,3.425-.245,5.138a72.824,72.824,0,0,1-4.159,18.473c-7.218,19.085-22.388,31.685-38.659,30.34-11.255-.979-20.675-8.441-26.792-19.452a57.778,57.778,0,0,1-6.484-20.063,56.9,56.9,0,0,1-.612-8.074,58.159,58.159,0,0,1,.245-7.952c.122-1.59.367-3.181.612-4.771,4.037-26.425,22.265-45.754,42.206-43.919C302.568,180.412,317.126,202.555,316.759,229.1Z",
    transform: "translate(-222.142 -146.923)",
    fill: "#fdb2d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1626",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1626",
    d: "M309.066,225.127c0,1.713-.122,3.425-.245,5.138a72.826,72.826,0,0,1-4.159,18.473c-37.313-26.058-29.85-52.238-29.85-52.238Z",
    transform: "translate(-214.449 -142.947)",
    fill: "#f78dbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1627",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1627",
    d: "M281.571,193.3s-9.42,30.829-24.223,37.191a29.225,29.225,0,0,1-17.739,1.468,58.168,58.168,0,0,1,.245-7.952c.122-1.59.367-3.181.612-4.771Z",
    transform: "translate(-222.187 -143.662)",
    fill: "#f78dbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1628",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1628",
    d: "M290.737,190.079s-22.51,39.76-49.914,43.8-13.946-33.521,6.117-46.611S296.12,165.122,290.737,190.079Z",
    transform: "translate(-225.359 -147.904)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1629",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1629",
    d: "M276.34,180.4c-.979,0-5.872,23.489,1.957,40.249s31.074,31.074,31.074,31.074S338.365,179.3,276.34,180.4Z",
    transform: "translate(-214.509 -146.546)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1630",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1630",
    d: "M275.858,194.437s-14.436-43.308,19.452-40c50.77,4.894,61.536,47.467,6.729,58.355",
    transform: "translate(-214.761 -152.384)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1631",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1631",
    d: "M283.5,228.114s.856-19.207,7.952-17.494,11.5,18.351,5.75,23.367c-5.628,5.016-10.032,1.957-10.032,1.957Z",
    transform: "translate(-212.372 -139.818)",
    fill: "#fdb2d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1632",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1632",
    d: "M274.1,174.431a39.125,39.125,0,0,1,28.627,9.175c13.58,11.377,12.356,20.92,12.356,20.92S309.945,180.671,274.1,174.431Z",
    transform: "translate(-214.472 -147.915)",
    fill: "#fcaa24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1633",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1633",
    d: "M287,216.995s1.713-4.649,4.037-3.67,7.34,8.2,5.628,13.09-4.649,4.4-4.649,4.4,5.016-3.915,3.3-8.808S290.425,213.2,287,216.995Z",
    transform: "translate(-211.59 -139.219)",
    fill: "#f973aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1634",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1634",
    d: "M276.7,176.928s-7.585-10.276-2.814-18.228C273.888,158.7,270.218,164.695,276.7,176.928Z",
    transform: "translate(-214.871 -151.391)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1635",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1635",
    d: "M324.693,194.089s-10.888,6.484-16.393-.489C308.3,193.6,312.46,198.983,324.693,194.089Z",
    transform: "translate(-206.832 -143.595)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1636",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1636",
    d: "M309.365,227.6a21.363,21.363,0,0,1-.489,6.851,42.421,42.421,0,0,1-1.957,6.729,25.222,25.222,0,0,1-1.468,3.181c-.245.489-.489,1.1-.734,1.59l-.856,1.468a2.559,2.559,0,0,1-.489.734l-.489.734c-.367.489-.612.979-.979,1.468-.734.856-1.468,1.835-2.2,2.691h0c.367-.489.612-.979.979-1.468a10.205,10.205,0,0,0,.979-1.468,10.213,10.213,0,0,1,.979-1.468l.489-.734.367-.734.856-1.468a9.118,9.118,0,0,1,.856-1.468c.612-.979.979-2.08,1.468-3.058a37.825,37.825,0,0,0,2.08-6.606,33.587,33.587,0,0,0,.612-6.973Z",
    transform: "translate(-208.753 -136)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1637",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1637",
    d: "M310.563,234.995l-.489-.245c5.995-14.191,3.792-24.59.856-30.707a30.206,30.206,0,0,0-7.83-10.154l.367-.489a28.93,28.93,0,0,1,8.074,10.276C314.355,210.038,316.68,220.559,310.563,234.995Z",
    transform: "translate(-207.994 -143.64)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1638",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1638",
    d: "M273.587,178.6c-4.526,1.713-9.053,3.67-13.335,5.75-2.2,1.1-4.282,2.2-6.484,3.425a64.69,64.69,0,0,0-6.117,3.915,33.387,33.387,0,0,0-5.383,4.771,25.81,25.81,0,0,0-2.324,2.814c-.734.979-1.468,1.957-2.08,2.936a52.913,52.913,0,0,0-3.792,6.239,46.028,46.028,0,0,0-2.814,6.729,16.6,16.6,0,0,0-.734,3.548,7.855,7.855,0,0,0,.245,3.425c0,.122.122.245.122.367.122.122.122.245.245.367a1.222,1.222,0,0,0,.612.489,7.014,7.014,0,0,0,1.713.489,17.192,17.192,0,0,0,3.548,0,46.633,46.633,0,0,0,13.947-3.792,46.273,46.273,0,0,0,12.234-7.83,50.977,50.977,0,0,0,5.016-5.26,46.941,46.941,0,0,0,3.915-6.117,36.664,36.664,0,0,1-8.686,11.622,43.018,43.018,0,0,1-12.234,7.952,65.632,65.632,0,0,1-6.851,2.569,35.787,35.787,0,0,1-7.218,1.346,18.4,18.4,0,0,1-3.67,0,10.194,10.194,0,0,1-1.835-.489,3.717,3.717,0,0,1-.856-.612.636.636,0,0,1-.245-.489c-.122-.122-.122-.245-.245-.489a7.564,7.564,0,0,1-.367-3.67,19.5,19.5,0,0,1,.734-3.67,41.026,41.026,0,0,1,2.814-6.729,52.913,52.913,0,0,1,3.792-6.239l2.2-2.936a25.81,25.81,0,0,1,2.324-2.814,26.711,26.711,0,0,1,2.691-2.569l1.468-1.1c.245-.245.489-.367.734-.612l.734-.489a53.675,53.675,0,0,1,6.239-3.915,64.576,64.576,0,0,1,6.484-3.3c2.2-.979,4.4-1.957,6.729-2.936C268.938,180.313,271.263,179.456,273.587,178.6Z",
    transform: "translate(-224.357 -146.946)",
    fill: "#6f69c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1639",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1639",
    d: "M270.976,176.6a44.744,44.744,0,0,0-6.851,1.223,68.561,68.561,0,0,0-6.606,2.08,61.661,61.661,0,0,0-12.356,6.239c-.979.612-1.957,1.346-2.814,1.957-.856.734-1.835,1.346-2.691,2.2-.489.367-.856.734-1.346,1.1l-1.223,1.223a11.536,11.536,0,0,0-1.223,1.223l-.612.612-.612.612c-.734.856-1.59,1.713-2.324,2.569-.367.489-.734.856-1.1,1.346l-1.1,1.346-.489.734c-.122.245-.367.489-.489.734l-.979,1.346-.245.367-.245.367-.489.734-.979,1.468,1.835-2.936.979-1.468c.122-.245.367-.489.489-.734l.489-.734,1.1-1.346c.367-.489.734-.856,1.1-1.346.734-.856,1.468-1.713,2.324-2.569a61.109,61.109,0,0,1,5.016-4.771c.856-.734,1.835-1.468,2.691-2.2.979-.734,1.835-1.346,2.814-1.957A58.109,58.109,0,0,1,257.4,179.9,38.125,38.125,0,0,1,270.976,176.6Z",
    transform: "translate(-225.171 -147.393)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_26",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 26",
    cx: 10.521,
    cy: 10.521,
    r: 10.521,
    transform: "translate(48.985 94.046)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1640",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1640",
    d: "M254.147,241.743a10.423,10.423,0,0,1-7.463,10.032,57.775,57.775,0,0,1-6.484-20.063,10.428,10.428,0,0,1,13.946,10.032Z",
    transform: "translate(-222.044 -135.219)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1641",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1641",
    d: "M254.767,231.53a19.3,19.3,0,0,0-2.936-1.835,7.039,7.039,0,0,0-3.181-.612,7.112,7.112,0,0,0-3.058,1.1,15.154,15.154,0,0,0-2.691,2.2,8.688,8.688,0,0,1,2.324-2.814,6.68,6.68,0,0,1,3.425-1.468,5.9,5.9,0,0,1,3.548.856A8.565,8.565,0,0,1,254.767,231.53Z",
    transform: "translate(-221.441 -135.893)",
    fill: "#f78dbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1642",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1642",
    d: "M270.867,229.23a19.28,19.28,0,0,0-2.936-1.835,7.038,7.038,0,0,0-3.181-.612,7.111,7.111,0,0,0-3.058,1.1,15.156,15.156,0,0,0-2.691,2.2,8.689,8.689,0,0,1,2.324-2.814,6.681,6.681,0,0,1,3.425-1.468,5.9,5.9,0,0,1,3.548.856A8.565,8.565,0,0,1,270.867,229.23Z",
    transform: "translate(-217.845 -136.407)",
    fill: "#f78dbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1643",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1643",
    d: "M257.32,233.6c-.612,1.59-1.1,3.181-1.59,4.894a17.9,17.9,0,0,0-.612,2.447,21.606,21.606,0,0,0-.489,2.447,8.188,8.188,0,0,0,0,2.447,2.427,2.427,0,0,0,1.223,1.957,3.787,3.787,0,0,0,2.324.122,18.574,18.574,0,0,0,2.447-.734,13.565,13.565,0,0,1-2.324,1.1,4.4,4.4,0,0,1-1.346.245,2.634,2.634,0,0,1-1.346-.245,1.736,1.736,0,0,1-1.1-.979,5.114,5.114,0,0,1-.489-1.223,9.9,9.9,0,0,1,0-2.691,33.368,33.368,0,0,1,1.223-5.016A43.02,43.02,0,0,1,257.32,233.6Z",
    transform: "translate(-218.978 -134.66)",
    fill: "#f78dbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1644",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1644",
    d: "M272.219,245.8s-3.425,10.276-10.766,9.053a11.146,11.146,0,0,1-9.053-7.34,13.582,13.582,0,0,0,1.59.489c3.181.979,10.766,2.447,17.494-1.713h0A3.805,3.805,0,0,1,272.219,245.8Z",
    transform: "translate(-219.319 -131.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1645",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1645",
    d: "M288.5,152.939a50.581,50.581,0,0,1,11.377.245c1.835.245,3.792.612,5.628.979.979.245,1.835.489,2.814.734a22.824,22.824,0,0,1,2.691.856,39.766,39.766,0,0,1,5.26,2.2,31.847,31.847,0,0,1,4.893,2.814,38.843,38.843,0,0,1,8.441,7.707,42.415,42.415,0,0,0-4.16-3.915l-.489-.489-.612-.489-.979-.734c-.734-.489-1.59-1.1-2.324-1.59a45.674,45.674,0,0,0-10.154-4.893,65.771,65.771,0,0,0-11.01-2.691c-1.835-.245-3.792-.489-5.627-.612C292.292,152.939,290.457,152.939,288.5,152.939Z",
    transform: "translate(-211.255 -152.726)",
    fill: "#1f107e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1646",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1646",
    d: "M284.078,283.227C275.759,282,272.7,276.621,271.6,273.44c2.2,2.447,7.83,7.952,14.436,8.2,8.319.245,17.861-6.973,17.861-6.973s4.771-4.894,5.383-8.564C313.684,271.605,295.823,284.94,284.078,283.227Z",
    transform: "translate(-215.03 -127.4)",
    fill: "#ef8ec3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_281",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 281",
    transform: "translate(78.224 91.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1647",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1647",
    d: "M296.618,232.961c0,2.936-1.59,5.26-3.67,5.26-1.59,0-3.058-1.59-3.425-3.67h0a6.461,6.461,0,0,1-.122-1.59c0-2.936,1.59-5.261,3.67-5.261a3.764,3.764,0,0,1,3.181,2.569h0A20.326,20.326,0,0,1,296.618,232.961Z",
    transform: "translate(-289.278 -227.7)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1648",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1648",
    d: "M296.273,231.959c0,2.936-1.59,5.261-3.67,5.261a3.764,3.764,0,0,1-3.181-2.569h0a6.461,6.461,0,0,1-.122-1.59c0-2.936,1.59-5.26,3.67-5.26a3.764,3.764,0,0,1,3.181,2.569h0A6.461,6.461,0,0,1,296.273,231.959Z",
    transform: "translate(-289.3 -227.678)",
    fill: "#fcaa24"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_292",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 292",
    transform: "translate(66.095 353.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_291",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_290",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1649",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1649",
    d: "M110.688,380.312c0-1.957,0-3.792-.122-5.75-.122-1.835-.367-3.792-.612-5.628A85.632,85.632,0,0,0,107.63,357.8a86.569,86.569,0,0,0-3.792-10.766A78.287,78.287,0,0,0,98.577,337,68.484,68.484,0,0,0,83.652,320c-1.468-1.223-2.936-2.324-4.526-3.425a26.218,26.218,0,0,0-2.324-1.59c-.367-.245-.856-.489-1.223-.734s-.856-.489-1.223-.734A78.26,78.26,0,0,0,64.2,308.5a87.849,87.849,0,0,1,10.154,5.138c.367.245.856.489,1.223.734s.856.489,1.223.734c.734.489,1.59,1.1,2.324,1.59,1.59,1.1,3.058,2.2,4.526,3.425a70.306,70.306,0,0,1,14.681,17.127,77.5,77.5,0,0,1,5.138,10.032,84.175,84.175,0,0,1,3.67,10.643,85.309,85.309,0,0,1,2.2,11.133c.245,1.835.489,3.792.612,5.628a43.221,43.221,0,0,1,.122,5.628h0c0,.245.122.489.367.489a.636.636,0,0,0,.245-.489Z",
    transform: "translate(-61.963 -304.211)",
    fill: "#617893"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_289",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_284",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 284",
    transform: "translate(28.082 47.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1650",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1650",
    d: "M104.5,357.725s-15.782-14.436-18.962-4.037C82.97,361.884,104.5,357.725,104.5,357.725Z",
    transform: "translate(-85.326 -342.785)",
    fill: "#6a96ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1651",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1651",
    d: "M101,359.15s5.505-20.675,13.7-13.579C121.308,351.076,101,359.15,101,359.15Z",
    transform: "translate(-81.825 -344.088)",
    fill: "#8fb8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_285",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 285",
    transform: "translate(25.347 33.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1652",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1652",
    d: "M101.331,345.5S85.549,332.772,83.225,342.8C81.267,350.878,101.331,345.5,101.331,345.5Z",
    transform: "translate(-83.09 -330.621)",
    fill: "#6a96ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1653",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1653",
    d: "M98,347.016s3.792-19.819,12.111-13.7C116.6,338.208,98,347.016,98,347.016Z",
    transform: "translate(-79.76 -332.142)",
    fill: "#8fb8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_286",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 286",
    transform: "translate(19.362 18.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1654",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1654",
    d: "M96.551,334.4s-17.984-9.3-18.351.979C77.956,343.58,96.551,334.4,96.551,334.4Z",
    transform: "translate(-78.198 -317.782)",
    fill: "#6a96ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1655",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1655",
    d: "M93.2,336.613s-.122-20.186,9.175-15.9C109.716,324.257,93.2,336.613,93.2,336.613Z",
    transform: "translate(-74.847 -320.113)",
    fill: "#8fb8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_287",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 287",
    transform: "translate(5.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1656",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1656",
    d: "M78.974,315.316s-14.069-1.223-11.622,5.505C69.31,326.2,78.974,315.316,78.974,315.316Z",
    transform: "translate(-67.066 -302.708)",
    fill: "#6a96ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1657",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1657",
    d: "M77.167,317.725S71.662,304.634,78.879,305C84.507,305.246,77.167,317.725,77.167,317.725Z",
    transform: "translate(-65.259 -304.994)",
    fill: "#8fb8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_288",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 288",
    transform: "translate(12.922 7.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1658",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1658",
    d: "M87.573,322.661s-15.9-4.894-14.558,3.425C73.993,332.815,87.573,322.661,87.573,322.661Z",
    transform: "translate(-72.934 -308.409)",
    fill: "#6a96ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1659",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1659",
    d: "M84.9,325.125s-3.058-16.271,5.016-14.191C96.526,312.646,84.9,325.125,84.9,325.125Z",
    transform: "translate(-70.387 -310.75)",
    fill: "#8fb8f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1660",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1660",
    d: "M73.661,312.9s-9.053-8.931-11.133-2.814C60.816,314.985,73.661,312.9,73.661,312.9Z",
    transform: "translate(-62.371 -304.334)",
    fill: "#a2c7fc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1661",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1661",
    d: "M127.928,364.884l-7.585,40.127-.489,2.447H89.269l-7.952-42.573a5.63,5.63,0,0,1,.489-3.548A5.423,5.423,0,0,1,86.7,358.4h35.845A5.4,5.4,0,0,1,127.928,364.884Z",
    transform: "translate(-58.161 -293.064)",
    fill: "#fcaa24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1662",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1662",
    d: "M120.466,404.474l-.489,2.447H89.269l-7.952-42.573a5.63,5.63,0,0,1,.489-3.548c1.468,6.606,5.75,22.632,12.845,31.441C100.769,399.948,113.37,403.251,120.466,404.474Z",
    transform: "translate(-58.161 -292.528)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1663",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1663",
    d: "M101.3,359.86s17.372-.734,18.718,0,1.957,3.548,1.957,3.548l-2.08,9.053s1.468-8.808.489-10.4C119.651,360.594,101.3,359.86,101.3,359.86Z",
    transform: "translate(-53.676 -292.811)",
    fill: "#f7c481"
  })), /*#__PURE__*/React.createElement("image", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_51",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 51",
    width: 33.031,
    height: 41.595,
    transform: "translate(31.353 70.963)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAiCAYAAACuoaIwAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALJJREFUeNrMV8kNgDAMSyLWYBHm4cs0fJmHRViEV6U+UI/UMY3EiyquHccIEVDd17HWzhiiUXrfAlgFSg+FWUtt+/nAwFqaNcskhDJhF4sZVXqqjAtzRDqFHyJWwpjupBrEwqLp732z6EUemlkO2Cv3sEHC5puz8siqtcZfN/dKaZ64SQBQCaf+ztXmaZEmmicbESlRMo0ikqGbGT3pSxLCg9jDrucSilIC+mOBSPxXgAEAbuVwEdjpnhIAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_293",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 293",
    transform: "translate(147.118 361.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1664",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1664",
    d: "M247.516,391.2H242.5v7.218h5.016",
    transform: "translate(-103.158 -294.064)",
    fill: "#426bc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1665",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1665",
    d: "M267.943,415.864H140.222L128.6,313.1H256.32Z",
    transform: "translate(-128.6 -311.51)",
    fill: "#6c90fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_52",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 52",
    width: 39.148,
    height: 7.218,
    transform: "translate(144.358 97.136)",
    fill: "#5c84ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1666",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1666",
    d: "M233,313.39l5.505-1.59,11.01,102.519-4.893,1.835Z",
    transform: "translate(-105.28 -311.8)",
    fill: "#5c84ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1667",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1667",
    d: "M128.6,313.39l6.362-1.59H261.826l-5.505,1.59Z",
    transform: "translate(-128.6 -311.8)",
    fill: "#aac0f9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_27",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 27",
    cx: 12.601,
    cy: 10.766,
    rx: 12.601,
    ry: 10.766,
    transform: "translate(56.398 40.494)",
    fill: "#afc4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1668",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1668",
    d: "M249.714,415.864H140.222L128.6,313.1C128.967,315.424,145.483,410.725,249.714,415.864Z",
    transform: "translate(-128.6 -311.51)",
    fill: "#5e8fdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1669",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1669",
    d: "M198.4,313.9h41.35l2.936,28.015-4.527-26.18Z",
    transform: "translate(-113.008 -311.331)",
    fill: "#a0bdf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_294",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 294",
    transform: "translate(287.985 89.791)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_53",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 53",
    width: 81.722,
    height: 46.611,
    transform: "matrix(0.932, -0.363, 0.363, 0.932, 0, 29.706)",
    fill: "#b3c2e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1670",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1670",
    d: "M319.315,89.9l-1.223.489L305,120.484l-.367.734-8.686,19.819-19.7-8.686-.856-.367-29.973-13.212-1.223.489,30.829,13.579-12.968,29.606,1.223-.489,12.6-28.749,20.553,9.053,9.053-20.675,28.749,12.6,1.223-.367-29.606-12.968Z",
    transform: "translate(-243.645 -89.766)",
    fill: "#ebf0fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_295",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 295",
    transform: "translate(91.577 236.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1671",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1671",
    d: "M213.612,245.5V234.612A24.722,24.722,0,0,0,188.9,209.9H107.912A24.722,24.722,0,0,0,83.2,234.612V245.5a24.722,24.722,0,0,0,24.712,24.712h58.233l40.738,12.111L200.155,267.4A24.114,24.114,0,0,0,213.612,245.5Z",
    transform: "translate(-83.2 -209.9)",
    fill: "#b3c2e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1672",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1672",
    d: "M190.789,226.606H99.4a3.289,3.289,0,0,1-3.3-3.3h0a3.289,3.289,0,0,1,3.3-3.3h91.264a3.289,3.289,0,0,1,3.3,3.3h0A3.265,3.265,0,0,1,190.789,226.606Z",
    transform: "translate(-80.318 -207.644)",
    fill: "#ebf0fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1673",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1673",
    d: "M190.789,238.006H99.4a3.289,3.289,0,0,1-3.3-3.3h0a3.289,3.289,0,0,1,3.3-3.3h91.264a3.289,3.289,0,0,1,3.3,3.3h0A3.265,3.265,0,0,1,190.789,238.006Z",
    transform: "translate(-80.318 -205.097)",
    fill: "#ebf0fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1674",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1674",
    d: "M156.145,249.284H98.769a2.584,2.584,0,0,1-2.569-2.569v-1.346a2.584,2.584,0,0,1,2.569-2.569h57.376a2.584,2.584,0,0,1,2.569,2.569v1.346A2.44,2.44,0,0,1,156.145,249.284Z",
    transform: "translate(-80.296 -202.551)",
    fill: "#ebf0fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_298",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 298",
    transform: "translate(436.569 413.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_296",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1675",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1675",
    d: "M404.905,361.347v7.707a2.454,2.454,0,0,1-2.447,2.447h-.612a2.454,2.454,0,0,1-2.447-2.447v-7.707a2.067,2.067,0,0,1,.367-1.223,2.523,2.523,0,0,1,2.08-1.223h.612a2.554,2.554,0,0,1,1.958.979A1.95,1.95,0,0,1,404.905,361.347Z",
    transform: "translate(-357.56 -353.395)",
    fill: "#f79c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1676",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1676",
    d: "M393.005,361.347v7.707a2.454,2.454,0,0,1-2.447,2.447h-.612a2.454,2.454,0,0,1-2.447-2.447v-7.707a2.067,2.067,0,0,1,.367-1.223,2.523,2.523,0,0,1,2.08-1.223h.612a2.554,2.554,0,0,1,1.957.979A1.95,1.95,0,0,1,393.005,361.347Z",
    transform: "translate(-360.219 -353.395)",
    fill: "#f79c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1677",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1677",
    d: "M425.862,403.868H375.214c-3.181,0-5.26-4.037-4.159-7.707l1.1-3.548,6.973-22.265a4.483,4.483,0,0,1,4.159-3.548H417.91c1.835,0,3.425,1.468,4.16,3.548l5.872,18.84,2.08,6.851C431.244,399.831,429.042,403.868,425.862,403.868Z",
    transform: "translate(-363.959 -351.63)",
    fill: "#fcaa24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1678",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1678",
    d: "M393.005,361.168v2.324H387.5v-2.324a2.067,2.067,0,0,1,.367-1.223l4.649-.245A1.95,1.95,0,0,1,393.005,361.168Z",
    transform: "translate(-360.219 -353.216)",
    fill: "#ef7352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1679",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1679",
    d: "M404.905,361.168v2.324H399.4v-2.324a2.067,2.067,0,0,1,.367-1.223l4.649-.245A1.95,1.95,0,0,1,404.905,361.168Z",
    transform: "translate(-357.56 -353.216)",
    fill: "#ef7352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1680",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1680",
    d: "M425.862,399.758H375.214c-3.181,0-5.26-4.037-4.159-7.707l1.1-3.548c1.223,1.223,3.67,2.691,8.441,4.282,13.212,4.4,37.191,1.713,37.191,1.713a17.8,17.8,0,0,0,10.154-9.3l2.08,6.851C431.244,395.721,429.042,399.758,425.862,399.758Z",
    transform: "translate(-363.959 -347.52)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1681",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1681",
    d: "M438.725,371.16a3.55,3.55,0,0,1-3.548,3.548h-7.585a3.535,3.535,0,0,1-3.425-2.814c-.612-2.936-2.447-7.218-6.973-8.319-.245,0-.489-.122-.734-.122H387.465a1.552,1.552,0,0,0-.734.122c-4.527,1.1-6.362,5.383-6.973,8.319a3.642,3.642,0,0,1-3.425,2.814h-7.585a3.55,3.55,0,0,1-3.548-3.548,23.231,23.231,0,0,1,1.957-9.787c2.569-5.26,9.909-6.729,11.377-6.973H425.39c1.468.245,8.808,1.59,11.377,6.973A22.085,22.085,0,0,1,438.725,371.16Z",
    transform: "translate(-365.2 -354.4)",
    fill: "#fcaa24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1682",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1682",
    d: "M433.493,373.431H426.52a3.535,3.535,0,0,1-3.425-2.814c-.612-2.936-2.447-7.218-6.973-8.319-.245,0-.489-.122-.734-.122H386.393a1.552,1.552,0,0,0-.734.122c-4.526,1.1-6.362,5.383-6.973,8.319a3.642,3.642,0,0,1-3.425,2.814H370c.367,0,7.585-.979,7.952-6.606.245-5.628,9.175-6.606,17.617-6.239s19.819-1.223,22.877,0c3.181,1.223,5.26,4.527,5.995,7.707.734,3.3,6.239,4.771,8.564,4.893C433.371,373.187,433.493,373.309,433.493,373.431Z",
    transform: "translate(-364.128 -353.123)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1683",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1683",
    d: "M366.6,363.764s1.713-7.707,11.5-8.564A20.018,20.018,0,0,0,366.6,363.764Z",
    transform: "translate(-364.887 -354.221)",
    fill: "#f9d298"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1684",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1684",
    d: "M377,375.774l1.59-5.628a3.279,3.279,0,0,1,3.425-2.447h7.463l-7.1,1.223s-2.447.856-2.936,1.958S377,375.774,377,375.774Z",
    transform: "translate(-362.564 -351.429)",
    fill: "#f9d298"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_297",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 297",
    transform: "translate(26.547 23.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1685",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1685",
    d: "M394.607,376.725h-7.1a.578.578,0,0,1-.612-.612v-2.2a.578.578,0,0,1,.612-.612h7.1a.578.578,0,0,1,.612.612v2.2A.578.578,0,0,1,394.607,376.725Z",
    transform: "translate(-386.9 -373.3)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1686",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1686",
    d: "M405.307,376.725h-7.1a.578.578,0,0,1-.612-.612v-2.2a.578.578,0,0,1,.612-.612h7.1a.578.578,0,0,1,.612.612v2.2A.578.578,0,0,1,405.307,376.725Z",
    transform: "translate(-384.51 -373.3)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1687",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1687",
    d: "M394.607,381.325h-7.1a.578.578,0,0,1-.612-.612v-2.2a.578.578,0,0,1,.612-.612h7.1a.578.578,0,0,1,.612.612v2.2A.578.578,0,0,1,394.607,381.325Z",
    transform: "translate(-386.9 -372.272)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1688",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1688",
    d: "M405.307,381.325h-7.1a.578.578,0,0,1-.612-.612v-2.2a.578.578,0,0,1,.612-.612h7.1a.578.578,0,0,1,.612.612v2.2A.578.578,0,0,1,405.307,381.325Z",
    transform: "translate(-384.51 -372.272)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1689",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1689",
    d: "M394.607,385.925h-7.1a.578.578,0,0,1-.612-.612v-2.2a.578.578,0,0,1,.612-.612h7.1a.578.578,0,0,1,.612.612v2.2A.578.578,0,0,1,394.607,385.925Z",
    transform: "translate(-386.9 -371.245)",
    fill: "#f9835a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1690",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1690",
    d: "M405.307,385.925h-7.1a.578.578,0,0,1-.612-.612v-2.2a.578.578,0,0,1,.612-.612h7.1a.578.578,0,0,1,.612.612v2.2A.578.578,0,0,1,405.307,385.925Z",
    transform: "translate(-384.51 -371.245)",
    fill: "#f9835a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_301",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 301",
    transform: "translate(419.671 184.736)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_28",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 28",
    cx: 36.946,
    cy: 36.946,
    r: 36.946,
    transform: "translate(0 72.939) rotate(-80.776)",
    fill: "#b3c2e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_300",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 300",
    transform: "translate(16.969 19.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1691",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1691",
    d: "M410.329,225.975h0c-2.691,2.814-7.707,3.3-13.457,1.835a51.446,51.446,0,0,1-29.361-24.223c-2.569-5.383-3.058-10.276-.856-13.579h0a9.284,9.284,0,0,1,4.649-2.569,8.991,8.991,0,0,1,4.771.245,3.106,3.106,0,0,1,1.713,1.59,37,37,0,0,0,4.037,6.851,2.837,2.837,0,0,1,.489,2.2,8.888,8.888,0,0,1-1.957,4.037h0a2.96,2.96,0,0,0,.122,3.792,44.7,44.7,0,0,0,5.505,5.138,70.184,70.184,0,0,0,6.117,4.4,2.818,2.818,0,0,0,3.67-.612h0a9.452,9.452,0,0,1,3.548-2.691,3.059,3.059,0,0,1,2.324,0,33.842,33.842,0,0,0,7.463,2.569,2.649,2.649,0,0,1,1.835,1.346,8.991,8.991,0,0,1,1.1,4.649A9.869,9.869,0,0,1,410.329,225.975Z",
    transform: "translate(-365.259 -182.648)",
    fill: "#ebf0fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_299",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 299",
    transform: "translate(20.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1692",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1692",
    d: "M400.2,205.465a.635.635,0,0,1-.245-.489,15.328,15.328,0,0,0-1.59-5.383,16.573,16.573,0,0,0-3.67-4.526,17.612,17.612,0,0,0-5.138-2.814,14.682,14.682,0,0,0-5.628-.489.676.676,0,0,1-.122-1.346,16.445,16.445,0,0,1,11.989,3.67,14.646,14.646,0,0,1,4.037,5.016,17.082,17.082,0,0,1,1.835,5.995.685.685,0,0,1-.612.734C400.45,205.709,400.327,205.587,400.2,205.465Z",
    transform: "translate(-382.099 -181.956)",
    fill: "#ebf0fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1693",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1693",
    d: "M404.6,205.9a.636.636,0,0,1-.245-.489,20.628,20.628,0,0,0-2.08-7.1,18.673,18.673,0,0,0-4.771-5.872,19.751,19.751,0,0,0-6.729-3.548,18.581,18.581,0,0,0-7.34-.734.676.676,0,1,1-.122-1.346,21.094,21.094,0,0,1,7.83.734,19.468,19.468,0,0,1,7.218,3.792A18.461,18.461,0,0,1,403.5,197.7a20.143,20.143,0,0,1,2.2,7.585.685.685,0,0,1-.612.734A.735.735,0,0,1,404.6,205.9Z",
    transform: "translate(-382.211 -182.76)",
    fill: "#ebf0fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1694",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1694",
    d: "M408.725,206.258a.635.635,0,0,1-.245-.489,21.1,21.1,0,0,0-2.569-8.564,22,22,0,0,0-5.872-7.1,22.875,22.875,0,0,0-8.2-4.282,24.026,24.026,0,0,0-8.808-.856.676.676,0,1,1-.122-1.346,24.489,24.489,0,0,1,9.42.856,23.918,23.918,0,0,1,8.686,4.649,24.98,24.98,0,0,1,6.239,7.585,23.52,23.52,0,0,1,2.691,9.053.685.685,0,0,1-.612.734C409.092,206.381,408.847,206.381,408.725,206.258Z",
    transform: "translate(-382.3 -183.484)",
    fill: "#ebf0fc"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1695",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1695",
    d: "M542.146,412.182H49.37a3.681,3.681,0,0,1-3.67-3.67V400.07a3.681,3.681,0,0,1,3.67-3.67H542.024a3.681,3.681,0,0,1,3.67,3.67v8.441A3.5,3.5,0,0,1,542.146,412.182Z",
    transform: "translate(0 68.489)",
    fill: "#3c59e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.e9a07c3ac9b074d2ed6edaafd538d374.svg";
export { ForwardRef as ReactComponent };